import React, { PureComponent } from 'react';
import firebase from '../../firebase.js';
import Residents from '../residents';
import Tenancy from '../tenancy';
import Noise from '../noise';
import Rent from '../rent';
import PropertySales from '../property-sales';
import AirBnb from '../airbnb';
import Alert from '../alert';
import Crime from '../crime';
import { connect } from 'react-redux';

class Facts extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      census: null,
      rent: null,
      crime: null
    };
  }

  componentDidUpdate(prevProps, prevState) {
    this.props.sa !== prevProps.sa && this.queryFirebase('census', 'sa', 'GUID', 'GUID');
    this.props.lea !== prevProps.lea && this.queryFirebase('rent', 'lea', 'GUID', 'GUID');
    this.props.crime !== prevProps.crime && this.queryFirebase('crime', 'crime', 'SUB_CODE', 'Dist');
  }

  queryFirebase = (token, bound, mapkey, dbkey) => {
    if (this.props[bound])
    {
      try {
        const ref = firebase.database().ref(token).orderByChild(dbkey).equalTo(this.props[bound].properties[mapkey]).limitToFirst(1);
        ref.on('value', (snapshot) => {
          let data = snapshot.val();
          const newState = {};
          newState[token] = data[Object.keys(data)[0]];
          this.setState(newState);
        },(errorObject) => {
          console.log("The read failed: " + errorObject.code);
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      const newState = {};
      newState[token] = null;
      this.setState(newState);
    }
  }

  render() {
    return (
      <div
        style={{
          maxWidth: "620px",
          margin: "0 auto",
          padding: "0rem 1rem"
        }}
      >
        { this.props.region === "Locality" && 
          <div
            style={{
              margin: "0 .75rem 2rem"
            }}
          >
            <Alert emoji={"💡"} background="#e2f4ff" color="#53a8f3">
              Try searching for a specific address to get more detailed information.
            </Alert>
          </div>
        }
        { this.props.region !== "Locality" && <Residents data={this.state.census} /> }
        { this.props.region !== "Locality" && <Tenancy data={this.state.census} /> }
        { (this.props.region !== "Locality" && this.props.noise) && <Noise data={this.props.noise} /> }
        { this.props.properties && this.props.properties.ptsWithin.features.length > 3 && <PropertySales data={this.props.properties} /> }
        { this.props.airbnb && this.props.airbnb.ptsWithin.features.length > 3 && <AirBnb data={this.props.airbnb} /> }
        <Rent data={this.state.rent} />
        <Crime data={this.state.crime} /> 
      </div>);
  }
}

function mapStateToProps(state) {
  return {
    sa: state.sa,
    lea: state.lea,
    crime: state.crime,
    airbnb: state.airbnb,
    properties: state.properties,
    noise: state.noise
  }
}

export default connect(mapStateToProps)(Facts);
 


// WEBPACK FOOTER //
// ./src/components/facts/index.js